import { render } from "./load.vue?vue&type=template&id=37ae5d58&scoped=true"
import script from "./load.vue?vue&type=script&lang=js"
export * from "./load.vue?vue&type=script&lang=js"

import "./load.vue?vue&type=style&index=0&id=37ae5d58&scoped=true&lang=less"

import exportComponent from "G:\\B030transformer\\demo (2)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ae5d58"]])

export default __exports__